import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=3bbda44a&scoped=true&lang=pug"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=3bbda44a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbda44a",
  null
  
)

export default component.exports